import { app } from '../../../app';
import { Controller } from './users-shared-accounts.controller';

app.component('userSharedAccounts', {
    bindings: {sharedAccounts: '<'},
    controller: Controller,
    templateUrl: require('./users-shared-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.component.js